 <template>
  <v-dialog
    transition="fade-transition"
    v-model="showWait"
    persistent
    fullscreen
    class="noselect"
  >
    <div class="wait-box">
      <v-progress-circular
        indeterminate
        v-bind:size="70"
        v-bind:width="1"
      ></v-progress-circular>
      <h3 class="sub-title">{{ $lang(msg) }}</h3>
    </div>
  </v-dialog>
</template>
<script>
import bus from "@/bus";

export default {
  name: "fullscreen-wait",
  data() {
    return {
      showWait: false,
      msg: "Please Wait",
    };
  },
  created() {
    bus.$on("hideWait", () => {
      this.showWait = false;
    }),
      bus.$on("showWait", (msg = false) => {
        this.msg = msg ? msg : "Please Wait";
        this.showWait = true;
      });
  },
  beforeDestroy() {
    bus.$off("showWait");
    bus.$off("hideWait");
  },
};
</script>

<style scoped>
.wait-box {
  width: 100vw;
  height: 100vh;
  padding-top: 35vh;
  text-align: center;
  background: rgba(128, 128, 128, 0.3);
}
</style>
